import React from 'react'
import PropTypes from 'prop-types';

function NavControl({ fixed, menuState, handleClick }) {

  const iconClose = '\u2715';
  const iconMenu = '\u2630';

  return (
    <button
      type="button"
      className={`nav-control__button ${(menuState) ? 'open' : 'close'} ${(fixed) ? 'fixed' : ''}`}
      onClick={handleClick}
    >
      {(menuState) ? iconClose : iconMenu}
    </button>
  )
}


NavControl.propTypes = {
  fixed: PropTypes.bool,
  menuState: PropTypes.bool,
  handleClick: PropTypes.func
};

NavControl.defaultProps = {
  fixed: false,
  menuState: false,
  handleClick: () => { }
}

export default NavControl
